import React from 'react'

export default () => (
<svg width="31" height="281" viewBox="0 0 31 281" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clipProdArr10)">
<path d="M10 281L6.47141e-07 274.013L10 267L10 281Z" fill="#1A98FF"/>
</g>
<g clipPath="url(#clipProdArr11)">
<path d="M17 10L23.9873 1.56674e-06L31 10L17 10Z" fill="#1A98FF"/>
</g>
<path d="M10 274L24 274L24 8" stroke="#1A98FF" strokeWidth="2" strokeMiterlimit="10" strokeDasharray="10 10"/>
<defs>
<clipPath id="clipProdArr10">
<rect width="14" height="10" fill="white" transform="translate(10 267) rotate(90)"/>
</clipPath>
<clipPath id="clipProdArr11">
<rect width="14" height="10" fill="white" transform="translate(31 10) rotate(180)"/>
</clipPath>
</defs>
</svg>
)
